import React from "react";
import ProductComingSoonLanding from "./ProductComingSoonLanding.jsx";

const HERO_TAGS = ["Hire purchase", "Finance lease", "Equipment"];

const FEATURE_CARDS = [
  {
    title: "Payment & term modelling",
    description:
      "Estimate indicative monthly payments, deposits, and optional balloon structures for vehicles, plant, and machinery.",
  },
  {
    title: "Structure-aware matching",
    description:
      "Match hire purchase, finance lease, and operating-style options depending on how you want to own or use the asset.",
  },
  {
    title: "Shortlist & apply in one journey",
    description:
      "When live, compare asset finance lines side by side and continue to application in a single borrower flow.",
  },
];

const STEPS = [
  {
    title: "Enter asset & funding need",
    body: "Asset type, cost, VAT, and preferred term help lenders assess security and repayment profile.",
  },
  {
    title: "Compare structures & costs",
    body: "Review indicative instalments, fees, and end-of-term options across matched asset finance products.",
  },
  {
    title: "Shortlist and apply",
    body: "Save up to five products and apply online once asset finance sourcing is available.",
  },
];

const CRITERIA_CHIPS = [
  "Asset type & age",
  "New vs used",
  "Net / gross funding amount",
  "Deposit or VAT deposit",
  "Term & balloon",
  "Annual mileage / hours (if relevant)",
  "Trading history",
  "Sole trader / Ltd / LLP",
  "Balloon / residual value",
];

export default function AssetFinanceCalculator() {
  return (
    <ProductComingSoonLanding
      productLabel="Asset finance"
      heroTitle="Asset Finance Calculator"
      heroDescription="Fund vehicles, plant, and equipment with clear costs and lender matching. Coming soon."
      heroSrc="/Asset.webp"
      primaryCtaText="Source asset finance (Coming soon)"
      heroTags={HERO_TAGS}
      introTitle="Asset finance calculator (Coming soon)"
      introBody="Dynesourcer will combine indicative funding figures with lender criteria for hire purchase, leasing, and similar asset facilities. This preview explains what borrowers can expect when the product launches."
      featureCards={FEATURE_CARDS}
      howItWorksTitle="How asset finance will work on Dynesourcer"
      howItWorksIntro="You describe the asset and how you want to fund it; we surface lenders whose asset appetite fits your scenario."
      steps={STEPS}
      criteriaTitle="Typical asset finance criteria (preview)"
      criteriaIntro="Lenders vary by asset class and structure. These are common filters used to narrow asset finance results."
      criteriaChips={CRITERIA_CHIPS}
      ctaTitle="Planning an asset purchase?"
      ctaDescription="Walk through the borrower journey now. Asset finance calculations and sourcing will appear on this route when ready."
      ctaPrimary={{ to: "/explore-borrower-journey", label: "Explore borrower journey" }}
      ctaSecondary={{ to: "/sourcing/buy-to-let-mortgage-sourcing", label: "Try BTL sourcing today" }}
    />
  );
}
